export default __webpack_public_path__ + "static/media/user.09fb9fad.svg";